import IntroAvatar from './IntroAvatar'

export * from './IntroAvatar'

export default IntroAvatar
